import { DayLabel, DaysLayout } from './styles';
import React from 'react';
import { getWeekDaysLabels } from 'utils';
import { useLocale } from 'hooks/use-locale.hook';
import { resolveWeekStartsOn } from '@hqo/date-time/core';

export const DayLabels = (): JSX.Element => {
  const locale = useLocale();
  // CLDR week start per locale (fr-FR/de/en-GB start Monday; en-US/fr-CA/pt-PT start Sunday).
  const dayLabels = getWeekDaysLabels(locale, resolveWeekStartsOn(locale) === 1, true);

  return (
    <DaysLayout className="week-day-names" data-testid="week-day-names">
      {dayLabels.map(day => (
        <DayLabel key={day} className={`week-day-label-${day}`} data-cy={`${day}-label`} data-testid={`${day}-label`}>
          {day}
        </DayLabel>
      ))}
    </DaysLayout>
  );
};
